<template>
  <div ref="zipcodeContainer" class="flex-group" style="margin-bottom: 10px" />
</template>

<script>
export default {
  props: {
    modelValue: Object,
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue: {
      handler(newVal) {
        if (newVal && newVal.county && newVal.district) {
          this.initTwzipcode();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.initTwzipcode();
  },
  methods: {
    initTwzipcode() {
      const self = this;
      $(this.$refs.zipcodeContainer).twzipcode({
        countySel: this.modelValue?.county || '',
        districtSel: this.modelValue?.district || '',
        zipcodeIntoDistrict: true,
        countyName: 'city',
        districtName: 'town',
        onCountySelect() {
          self.updateModel();
        },
        onDistrictSelect() {
          self.updateModel();
        },
      });
    },
    updateModel() {
      const county = $(this.$refs.zipcodeContainer).find('[name="city"]').val();
      const district = $(this.$refs.zipcodeContainer).find('[name="town"]').val();
      const zipCode = $(this.$refs.zipcodeContainer).find('[name="zipcode"]').val();
      const newAddress = {
        ...this.modelValue,
        county,
        district,
        zipCode,
      };
      this.$emit('update:modelValue', newAddress);
    },
  },
};
</script>
